export const calculateImageCrop = ({
  naturalWidth,
  naturalHeight,
  outputWidth,
  outputHeight,
  zoom = 1,
  positionX = 50,
  positionY = 50,
}) => {
  if (!naturalWidth || !naturalHeight || !outputWidth || !outputHeight) return null;

  const sourceAspect = naturalWidth / naturalHeight;
  const outputAspect = outputWidth / outputHeight;
  let baseWidth;
  let baseHeight;

  if (sourceAspect > outputAspect) {
    baseHeight = naturalHeight;
    baseWidth = naturalHeight * outputAspect;
  } else {
    baseWidth = naturalWidth;
    baseHeight = naturalWidth / outputAspect;
  }

  const safeZoom = Math.max(1, Number(zoom) || 1);
  const width = baseWidth / safeZoom;
  const height = baseHeight / safeZoom;
  const normalizedX = Math.min(100, Math.max(0, Number(positionX) || 0)) / 100;
  const normalizedY = Math.min(100, Math.max(0, Number(positionY) || 0)) / 100;

  return {
    x: (naturalWidth - width) * normalizedX,
    y: (naturalHeight - height) * normalizedY,
    width,
    height,
  };
};

export const imageCropBackgroundSize = ({
  naturalWidth,
  naturalHeight,
  outputWidth,
  outputHeight,
  zoom = 1,
}) => {
  if (!naturalWidth || !naturalHeight || !outputWidth || !outputHeight) return 'cover';

  const sourceAspect = naturalWidth / naturalHeight;
  const outputAspect = outputWidth / outputHeight;
  const safeZoom = Math.max(1, Number(zoom) || 1);

  if (sourceAspect > outputAspect) {
    return `${(sourceAspect / outputAspect) * 100 * safeZoom}% ${100 * safeZoom}%`;
  }

  return `${100 * safeZoom}% ${(outputAspect / sourceAspect) * 100 * safeZoom}%`;
};

export const calculateImageDragPosition = ({ startPosition, delta, overflow }) => {
  if (!Number.isFinite(overflow) || overflow <= 0) return 50;
  const nextPosition = Number(startPosition) - (Number(delta) / overflow) * 100;
  return Math.min(100, Math.max(0, nextPosition));
};

export const clampImageZoom = (zoom, min = 1, max = 4) =>
  Math.min(max, Math.max(min, Number(zoom) || min));

export const calculateImageWheelZoom = ({ zoom, deltaY, min = 1, max = 4 }) => {
  const factor = Math.exp(-Number(deltaY || 0) * 0.002);
  return clampImageZoom(Number(zoom || min) * factor, min, max);
};

export const calculateImagePinchZoom = ({
  zoom,
  startDistance,
  currentDistance,
  min = 1,
  max = 4,
}) => {
  if (!Number.isFinite(startDistance) || startDistance <= 0) {
    return clampImageZoom(zoom, min, max);
  }
  return clampImageZoom(
    Number(zoom || min) * (Number(currentDistance || 0) / startDistance),
    min,
    max,
  );
};

export const renderCroppedImage = ({
  image,
  outputWidth,
  outputHeight,
  zoom,
  positionX,
  positionY,
  mimeType = 'image/webp',
  quality = 0.9,
}) => {
  const crop = calculateImageCrop({
    naturalWidth: image?.naturalWidth,
    naturalHeight: image?.naturalHeight,
    outputWidth,
    outputHeight,
    zoom,
    positionX,
    positionY,
  });

  if (!image || !crop) throw new Error('A imagem ainda não foi carregada.');

  const canvas = document.createElement('canvas');
  canvas.width = outputWidth;
  canvas.height = outputHeight;
  const context = canvas.getContext('2d');
  if (!context) throw new Error('Não foi possível preparar o ajuste da imagem.');

  context.drawImage(
    image,
    crop.x,
    crop.y,
    crop.width,
    crop.height,
    0,
    0,
    outputWidth,
    outputHeight,
  );

  return canvas.toDataURL(mimeType, quality);
};
